export default "__VITE_ASSET__BkDnftWV__"